export default "__VITE_ASSET__CEcsdoCE__"